export const HEADER_LOGO = "/ping-logo-horizontal.svg";
export const DISPLAY_NAME = "TAP Partner Vault";

export const menuItems = [];
